import * as React from 'react';
import { Header, Icon } from 'semantic-ui-react';
import { formatShortMonth, formatYearMonthTag } from '~/Date';
export var YearMonthPickerGrid = React.memo(function (_a) {
    var year = _a.year, selectedMonth = _a.selectedMonth, showingSelectedYear = _a.showingSelectedYear, onSelect = _a.onSelect;
    return (<div className='grid' role='rowgroup'>
		{[0, 1, 2, 3].map(function (quarter) { return (<div className='quarter' key={quarter} role='row'>
				{[0, 1, 2].map(function (month) {
                var tmpDate = new Date();
                tmpDate.setFullYear(year);
                tmpDate.setMonth(quarter * 3 + month);
                var value = formatYearMonthTag(tmpDate);
                return (<div className={"month ".concat(showingSelectedYear && selectedMonth === tmpDate.getMonth() ? 'selected' : '')} data-testid='month' key={month} role='gridcell' onClick={function () {
                        onSelect(value);
                    }}>
							{formatShortMonth(tmpDate, false, ['cs'])}
						</div>);
            })}
			</div>); })}
	</div>);
});
YearMonthPickerGrid.displayName = 'DatePicker.Grid';
export var YearMonthPicker = function (_a) {
    var value = _a.value, label = _a.label, onSelect = _a.onSelect;
    var _b = React.useState(function () {
        return value !== '' ? new Date(value).getFullYear() : new Date().getFullYear();
    }), year = _b[0], setYear = _b[1];
    var selectedMonth = React.useMemo(function () { return new Date(value !== null && value !== void 0 ? value : '').getMonth(); }, [value]);
    var showingSelectedYear = React.useMemo(function () { return year === new Date(value).getFullYear(); }, [value, year]);
    return (<div className='year-month-picker'>
			<Header.Content as='h5'>{label}</Header.Content>
			<div className='wrapper'>
				<div className='months' role='grid'>
					<div className='caption' role='heading'>
						<Icon data-testid='previous-year' name='angle left' onClick={function () {
            setYear(year - 1);
        }}/>
						{year}
						<Icon data-testid='next-year' name='angle right' onClick={function () {
            setYear(year + 1);
        }}/>
					</div>

					<YearMonthPickerGrid selectedMonth={selectedMonth} showingSelectedYear={showingSelectedYear} year={year} onSelect={onSelect}/>
				</div>
			</div>
		</div>);
};
YearMonthPicker.displayName = 'DatePicker.YearMonthPicker';
